module.exports = __webpack_public_path__ + "3-66.jpg?bbad1d4fce0c88ebcad5f621ce38de86";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-66.jpg
// module id = 148
// module chunks = 0